
import React, { useState } from 'react';
import './Main.css';
import { FaHeadset, FaMapMarkerAlt, FaMotorcycle } from 'react-icons/fa';
import { FaFacebook, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import image1 from './images/digital.png'
import image2 from './images/AI.png';
import image3 from './images/standardize.png';
import image4 from './images/trained.png';
import image5 from './images/find.png';
import image6 from './images/affordable.png';
import image7 from './images/promise.png';
import image8 from './images/trained - 11.png';
import image9 from './images/support.png';
import locationImage1 from './images/locationImage1.jpeg';
import locationImage2 from './images/locationImage2.jpeg';
import locationImage3 from './images/locationImage3.jpeg';
import locationImage4 from './images/locationImage4.jpeg';
import locationImage5 from './images/locationImage5.jpeg';
import logo from '../Components/images/companyLogo.png';
import demoImage from '../Components/images/bg2.jpg';

const Main = () => {
  const [showMenu, setShowMenu] = useState(false);
  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const imageUrls = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9
  ];

  const gridItems = [
    { id: 1, src: imageUrls[0], text: 'COMPLETELY DIGITAL', additionalText: '01', smalltext: "Right from mechanics to spares to providing services we are digital." },
    { id: 2, src: imageUrls[1], text: 'AI POWERED', additionalText: '02', smalltext: 'Our AI powered application helps mechanics and customers to find perfect fit spares just with vehicle registration number.' },
    { id: 3, src: imageUrls[2], text: 'STANDARDIZED', additionalText: '03', smalltext: 'All our garages are compliance with standard operating procedures, Kaizens and 5S' },
    { id: 4, src: imageUrls[3], text: 'WELL TRAINED', additionalText: '04', smalltext: 'All our mechanics and management are trained with the latest trends and technologies in the market.' },
    { id: 5, src: imageUrls[4], text: 'FIND US ANYWHERE', additionalText: '05', smalltext: 'Small or big garage, We aim to partner with as many garages as we can to give smoother and larger network experience to our customers.', },
    { id: 6, src: imageUrls[5], text: 'CHEAPER FOR SURE', additionalText: '06', smalltext: 'Having a larger network of garages will workout to provide the cheaper price to the end customers.' },
    { id: 7, src: imageUrls[6], text: 'OUR PROMISE', additionalText: '07', smalltext: 'We will stand as a mediator between local garages and the customers to make sure we deliver the best possible service.' },
    { id: 8, src: imageUrls[7], text: '', },
    { id: 9, src: imageUrls[8], text: '24*7 SUPPORT', additionalText: '09', smalltext: 'We are available 24x7 for any assistance on 8888222992.', }
  ];

  const locationItems = [
    { id: 1, src: locationImage1, text: 'Shree Sai Auto Service Center', description: 'MOTO001', location: 'https://www.google.com/maps/dir/15.8627008,74.5111716/Motocross+Garage+-+MOTO0001,+4th+Cross,+Main+Road,+Mahadwar+Rd,+Belagavi,+Karnataka+590001/@15.8569485,74.5099521,16z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x3bbf67fe35a6bc4b:0xf09035c54286084d!2m2!1d74.5190987!2d15.8526662?entry=ttu' },
    { id: 2, src: locationImage2, text: 'Sudhir Auto', description: 'MOTO002', location: 'https://www.google.com/maps?s=web&rlz=1C1RXQR_enIN1063IN1063&lqi=Chhtb3RvY3Jvc3MgZ2FyYWdlIGJlbGdhdW1aGiIYbW90b2Nyb3NzIGdhcmFnZSBiZWxnYXVtkgEWbW90b3JjeWNsZV9yZXBhaXJfc2hvcKoBYgoJL20vMDM1ejRwEAEqFCIQbW90b2Nyb3NzIGdhcmFnZSgAMh8QASIbuHTYCrPan7aOd-FCftSEtJStCiMp4fo6_k4LMhwQAiIYbW90b2Nyb3NzIGdhcmFnZSBiZWxnYXVt&vet=12ahUKEwjtoaTq6MaGAxWt2TgGHaSMBOMQ1YkKegQIGxAB..i&cs=0&um=1&ie=UTF-8&fb=1&gl=in&sa=X&geocode=KbETa0KzZ787MSOHZRPldEm6&daddr=Ramling+Khind+Rd,+Raviwar+Peth,+Belagavi,+Karnataka+590001' },
    { id: 3, src: locationImage3, text: 'Om Auto Garage', description: 'MOTO003', location: 'https://www.google.com/maps/dir//VGF5%2BV46,+behind+Maharastra+Bank,+Sadashiv+Nagar,+Belagavi,+Karnataka+590019/@15.8746365,74.4253571,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bbf61532789f657:0x3cd5414ed33e0d37!2m2!1d74.5077506!2d15.8746589?entry=ttu' },
    { id: 4, src: locationImage4, text: 'New Hero Bike Point', description: 'MOTO004', location: 'https://www.google.com/maps/dir//RGG5%2BHJX,+Seventh+Cross+Rd,+Bhagya+Nagar,+Angol,+Belagavi,+Karnataka+590006/@15.826477,74.4267164,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bbf667d71d170fd:0xc1388199a13d9bcc!2m2!1d74.5091027!2d15.8264919?entry=ttu' },
    { id: 5, src: locationImage5, text: 'New Model Auto Garage', description: 'MOTO005', location: 'https://www.google.com/maps/dir/15.8627008,74.5111716/new+model+auto+garage+bike+service+center+belgaum/@15.8699494,74.5055887,15z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x3bbf66b513846999:0xd9139ca64ef482a2!2m2!1d74.5205058!2d15.8730808?entry=ttu' },
  ];

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };


  const [query, setQuery] = useState('');

  const handleInputChange = (event) => {
    setQuery(event.target.value);
  };

  const handleSearch = (event) => {
    event.preventDefault();
    console.log(`Searching for: ${query}`);
  };



  return (
    <div>
      <div>
        <nav className={`one ${showMenu ? 'show-menu' : ''}`}>
          <div className="hamburger" onClick={toggleMenu}>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
          </div>

          <div className="logo">
            <img src={logo} alt="Motocross India" />
          </div>

          <div className={`nav-links ${showMenu ? 'show' : ''}`}>
            <a href="/login">Login</a>
            <a href="/Card">Partner</a>
            <a href="/TrainingForm">Training</a>
            <a href="https://mymotokart.com" target="_blank" rel="noopener noreferrer">Shop</a>
            <a href="/Applicationform">Career</a>
          </div>
        </nav>
      </div>
      <div className="fullscreen-image-container">
      <img 
      src={demoImage} 
      alt="Fullscreen Background" 
      className="fullscreen-image  h-60%" 
    />
      </div>
      <h1 className='head1'>
        WELCOME TO <span className='head2'>MOTOCROSS INDIA</span>
      </h1>
      <br />
      <div className="paragraph-container">
        <p>
          Motocross India, a pioneering startup based in Belagavi, Karnataka, India, was founded on October 12, 2018, and has gained recognition from the Department for Promotion of Industry and Internal Trade (DPIIT), Government of India. Operating under an innovative asset-light model, the company is poised to revolutionize the two-wheeler service industry. With a vision to establish itself as the premier local garage chain and the leading app-based two-wheeler reseller nationwide, Motocross India is committed to excellence.
        </p>
        <br />
        <p>
          At its core, Motocross India prioritizes empowering local mechanics with cutting-edge technological insights, ensuring that they stay ahead of the curve in vehicle servicing. Moreover, through its state-of-the-art AI-driven supply chain network, operating under the esteemed 'Motocross Garage' brand, the company ensures access to genuine/OES spare parts, thus guaranteeing top-notch service quality.
        </p>
        <p>
          <br />
          Currently, Motocross India is in the midst of a strategic pilot run, collaborating with 275 garages in the Belagavi District, KA. Looking ahead, by 2023, the company ambitiously aims to extend its partnership network to a staggering 5,000 garages nationwide, solidifying its position as an industry leader in the realm of two-wheeler servicing and sales.
        </p>
      </div>

      <div className="container">
        <div className="row1">
          <div className='icon1'><FaHeadset className="icon" /></div>
          <p className="text1">24/7 SERVICE SUPPORT</p>
        </div>

        <div className="row2">
          <div className='icon2'>
            <FaMotorcycle className="icon" />
          </div>
          <p className="text2">FREE PICKUP AND DROP</p>
        </div>

        <div className="row3">
          <div className='icon3'>
            <FaMapMarkerAlt className="icon" />
          </div>
          <p className="text3">LOTS OF PICKUP LOCATIONS</p>
        </div>
      </div>

      <div id="service" className="Service">
        <h1>WHAT WE DO?</h1>
      </div>
      <div className="grid-container">
        {gridItems.map(item => (
          <div key={item.id} className="grid-item">
            <div className="item-content">
              <img src={item.src} alt={`Image ${item.id}`} />
              <div className="text-content">
                <p>{item.additionalText}</p>
              </div>
            </div>
            <div className="additional-text">
              <h4>{item.text}</h4>
              <p>{item.smalltext}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="Offer">
        <div className="section">
          <h1>50% OFF</h1>
          <h2>SPECIAL OFFER FOR NEW MEMBERS</h2>
          <h3>Only for Sunday from 1st Dece to 30th Jan 2024</h3>
          <div className='btn'>
            <button>Register Now</button>
          </div>
        </div>
      </div>
      <div id='location' className='location'>
        <h2>NEARBY GARAGE</h2>
        <div className="location-grid">
          {locationItems.map(item => (
            <div key={item.id} className="location-item">
              <a href={item.location} target="_blank" rel="noopener noreferrer">
                <img src={item.src} alt={item.text} />
              </a>
              <h3>{item.text}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div>
        <h1 className="contact">CONTACT US</h1>
        <div className='contact-container'>
          <div className='cform'>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name"></label>
                  <input
                    type="text" id="name"
                    placeholder='Your Name'
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email"></label>
                  <input
                    type="email"
                    id="email"
                    placeholder='Your Email'
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="subject"></label>
                  <input
                    type="text"
                    id="subject"
                    placeholder='Subject'
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="message"></label>
                  <textarea
                    id="message"
                    name="message"
                    placeholder='Message'
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="form-row">
                <button type="submit">Send Message</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="contact-info-container">
        <div className="contact-box">
          <h2>GET IN TOUCH</h2>
          <div className="contact-block">
            <p><FaMapMarkerAlt />3rd Main, Club Road, Basavnagar, Belgaum - 590001</p><br />
            <p><FaPhoneAlt />8888222992</p><br />
            <p><FaEnvelope />info@motocrossindia.in</p>
            <h4>FOLLOW US</h4>
            <div className="social-media-container">
              <div className="inner-box">
                <a href="https://www.facebook.com/motocrossind/" target="_blank" rel="noopener noreferrer"><FaFacebook size={25} /></a>
              </div>
              <div className="inner-box">
                <a href="https://x.com/MotocrossIndia" target="_blank" rel="noopener noreferrer"><FaXTwitter size={25} /></a>
              </div>
              <div className="inner-box">
                <a href="https://www.instagram.com/motocrossind/" target="_blank" rel="noopener noreferrer"><FaInstagram size={25} /></a>
              </div>
              <div className="inner-box">
                <a href="https://www.youtube.com/channel/UCzzHG1i136eR4VFyJXBw0oA" target="_blank" rel="noopener noreferrer"><FaLinkedin size={25} /></a>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-box">
          <h2>USEFUL LINKS</h2>
          <div className="contact-block">
            <ul>
              <li><a href="/Card">Partners Agreement</a></li>
              <li><a href="/Card">Terms & Conditions</a></li>
              <li><a href="/Card">Refund Policy</a></li>
              <li><Link to='/privacy-policy'>Privacy policy</Link></li>
              <li><a href="/Card">Help & FAQs</a></li>
            </ul>
          </div>
        </div>
        <div className="contact-box">
          <h2>COMPANY</h2>
          <div className="contact-block">
            <ul>
              <li><a href='/support-form' target="_blank">Contact Us</a></li>
              <li><a href="#service">Our Services</a></li>
              <li><a href="#location">Service Points</a></li>
              <li><a href="#location">Nearby Garage</a></li>
              <li><a href="/Press" target="_blank">Press</a></li>
            </ul>
          </div>
        </div>
        <div className="contact-box">
          <h2>NEWSLETTER</h2>
          <div className="search-container">
            <input
              type="text"
              placeholder="Your Email"
              value={query}
              onChange={handleInputChange}
              className="SIGN UP"
            />
            <button type="submit" className="search-button" onClick={handleSearch}>SIGN UP</button>
          </div>
        </div>
      </div>
      <div className='footer'>
        <p className='p1'>
          Motocross India - Largest local garage chain for two-wheelers in Bharat driven by AI.</p><br />
        <p className='p2'> Copyright ©2018-2023. by Motocross India Private Limited.</p>
      </div>
    </div>
  );
};
export default Main;